/**
 * Standard response interfaces for API actions and data operations
 */

export enum ErrorCode {
  NOT_FOUND = 'NOT_FOUND',
  VALIDATION_ERROR = 'VALIDATION_ERROR',
  INTERNAL_ERROR = 'INTERNAL_ERROR',
  UNAUTHORIZED = 'UNAUTHORIZED',
  FORBIDDEN = 'FORBIDDEN',
  BAD_REQUEST = 'BAD_REQUEST'
}

// For server actions that modify data
export interface ActionResponse<T> {
  success: boolean           // Operation success status
  data?: T                  // Optional response data
  error?: string            // Error message if failed
  message?: string          // Success/info message
  code?: string            // Error code if failed
}

// For data fetch operations
export interface DataResponse<T> {
  success: boolean           // Operation success status
  data?: T                  // Optional response data
  error?: string            // Error message if failed
  message?: string          // Success/info message
  errorCode?: ErrorCode     // Error code if failed
}

// For registry operations (service registry, etc)
export interface RegistryResponse<T> {
  success: boolean          // Operation success status
  data?: T                 // Optional response data
  error?: string           // Error message if failed
}
